import React from 'react'
import IdPiano from '../../vendor/Piano/components/IdPiano'
import LayoutDefault from '../../layouts/Default'

const Login = ({ view, ...props }) => (
  <LayoutDefault {...props}>
    <IdPiano view={view} />
  </LayoutDefault>
)

Login.propTypes = {
  view: IdPiano.propTypes.view,
}

Login.defaultProps = {
  view: IdPiano.defaultProps.view,
}

export default Login
